<template>
    <div>
        <component :is="activeComponent" :service="service"></component>
    </div>
</template>

<script>
import Billing from './common/_Billing';
export default {
    props: ['service'],
    data() {
        return {
            activeComponent: Billing,
        }
    },
    created() {
        this.$store.commit('setCurrentService', this.service);
    },
    methods: {
    },
    computed: {
    }
}
</script>